import {
  toastMessageAtom, toastShowAtom, toastStatusAtom, toastTimeoutAtom,
} from '@states/uiAtoms';
import { useAtom, useSetAtom } from 'jotai';

const TOAST_TIMEOUT_MS = 2000;

function useToast() {
  const setIsShow = useSetAtom(toastShowAtom);
  const setMessage = useSetAtom(toastMessageAtom);
  const setStatus = useSetAtom(toastStatusAtom);
  const [hideTimeout, setHideTimeout] = useAtom(toastTimeoutAtom);
  const showToast = (message: string) => {
    setMessage(message);
    setIsShow(true);
    if (hideTimeout) {
      clearTimeout(hideTimeout);
    }
    const newTimeout = setTimeout(() => {
      setIsShow(false);
    }, TOAST_TIMEOUT_MS);
    setHideTimeout(newTimeout);
    return () => clearTimeout(hideTimeout);
  };
  const error = (message: string) => {
    setStatus('ERROR');
    showToast(message);
  };
  const info = (message: string) => {
    setStatus('INFO');
    showToast(message);
  };
  const success = (message: string) => {
    setStatus('SUCCESS');
    showToast(message);
  };
  return {
    error, info, success,
  };
}

export default useToast;
